import { HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { IConfigTipoDocumento } from 'src/app/shared/models/config-tipo-documento.model';
import { INotaFiscal, NotaFiscal } from 'src/app/shared/models/nota-fiscal.model';
import { Status } from 'src/app/shared/models/status.model';
import { ITipoDocumento } from 'src/app/shared/models/tipo-documento';
import { ConfigTipoDocumentoService } from 'src/app/shared/services/config-tipo-documento.service';
import { NotaFiscalService } from 'src/app/shared/services/nota-fiscal.service';
import { TipoDocumentoService } from 'src/app/shared/services/tipo-documento.service';
import { DataUtils } from 'src/app/shared/util/data-util.service';
import { TranslateModule } from '@ngx-translate/core';
import { TitleCasePipe, CurrencyPipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-car-detalhes',
    templateUrl: './car-detalhes.component.html',
    styleUrls: ['./car-detalhes.component.scss'],
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, TitleCasePipe, CurrencyPipe, DatePipe, TranslateModule]
})
export class CarDetalhesComponent implements OnInit{
    isLoading = false;
    isSaving = false;

    tipoDocumentosSharedCollection: ITipoDocumento[] = [];
    configTipoDocumentosSharedCollection: IConfigTipoDocumento[] = [];
    notaFiscal: NotaFiscal;
    dataRenovacao: Date;

    constructor(
      protected notaFiscalService: NotaFiscalService,
      protected fb: FormBuilder,
      protected dataUtils: DataUtils,
      public dialogRef: MatDialogRef<CarDetalhesComponent>,
      protected tipoDocumentoService: TipoDocumentoService,
      protected configTipoDocumentoService: ConfigTipoDocumentoService,
      @Inject(MAT_DIALOG_DATA) public data,
    ) { }

    onNoClick(): void {
      this.dialogRef.close();
    }


    ngOnInit(): void {
        this.isLoading = true;

        this.notaFiscalService.find(this.data).subscribe(
          (res: HttpResponse<INotaFiscal>) => {
            this.notaFiscal = res.body ?? null;
          },
          () => {
            this.isLoading = false;
          }
        );
      }


    openFile(base64String: string, contentType: string | null | undefined): void {
        return this.dataUtils.openFile(base64String, contentType);
    }

    openFileKML(data: string, contentType: string | null | undefined) {
      contentType = contentType ?? '';
      const byteCharacters = atob(data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {type: 'kml'});
      const anchor = document.createElement('a');
      anchor.download = data.substring(0, 5)+".kml";
      anchor.href = (window.webkitURL || window.URL).createObjectURL(blob);
      anchor.click();
    }

    renovar(notaFiscal: INotaFiscal): void {
        if(!this.dataRenovacao){
            alert('data invalida');
            return;
        }
        if(confirm('Tem certeza que deseja renovar esse CAR?')){
            this.isLoading = true;

            this.notaFiscalService.renovar(notaFiscal.id!, this.dataRenovacao).subscribe(
              (res: HttpResponse<INotaFiscal>) => {
                this.isLoading = false;
                this.notaFiscal = res.body ?? {};
                this.onNoClick();
              },
              () => {
                this.isLoading = false;
              }
            );
        }
      }


}
